module.exports = __webpack_public_path__ + "static/media/see-news.9d3fc197.png";